export default __webpack_public_path__ + "static/media/Dentec-Training-Logo.aaff3a25.png";